import React, { Component } from 'react'
// import { storeData } from '../../../storeData'

export default class Terminos extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='DefaultPage'>

<h2>
Términos y condiciones
</h2>

<p>
Estimado cliente y/o usuario, le recomendamos leer con especial cuidado el presente documento, dado que por el solo hecho de navegar por nuestra página web o adquirir cualquiera de nuestros productos por este medio, se aceptan plenamente los términos y condiciones que se mencionan a continuación:
</p>

<h2>
Las partes
</h2>

{/* <p>
Entre el cliente y/o usuario, quien actúa directamente, si es una persona natural o por medio de una persona debidamente facultada para actuar a nombre y representación, en caso de ser una persona jurídica, y de otro lado {storeData.domain}, marca nacional, sociedad comercial debidamente constituida bajo las leyes colombianas, que cuenta con un sitio web www.{storeData.domain}, celebran el presente contrato de conformidad con los términos y condiciones de uso que hacen parte integral de este contrato.
</p> */}
<p> 
Entre el cliente y/o usuario, quien actúa directamente, ya sea como persona natural o por medio de un representante debidamente facultado en caso de ser una persona jurídica, y de otro lado 10X BOOSTER LLC, una sociedad comercial constituida bajo las leyes de los Estados Unidos de América, que facilita la compra y venta de productos a través de su sitio web www.{storeData.domain}, celebran el presente contrato de conformidad con los términos y condiciones de uso que hacen parte integral de este contrato.
</p>

<p>
{storeData.domain} en todo caso presumirá de buena fe que está contratando directamente con el cliente o con su representante legal debidamente facultado para efectuar este tipo de operaciones y ninguna responsabilidad deberá asumir {storeData.domain} por suplantación personal que realice cualquier cliente y/o usuario.
Parágrafo primero: Para realizar cualquier compra, es requisito esencial identificarse y presentarse como usuario en la página web, actividades que se realizan por medio de una cuenta de correo electrónico y una clave secreta del cliente, la cual es de carácter personal, intransferible y de responsabilidad exclusiva y excluyente del cliente.
</p>

<p>
Parágrafo segundo: Es responsabilidad del cliente cualquier uso que de la clave suministrada se realice, la cual no podrá ser transferida o revelada a terceros bajo ningún motivo. Así mismo, el cliente deberá adoptar todas las medidas de seguridad necesarias para evitar el mal uso o el conocimiento de esta por parte de terceros. Se recomienda efectuar el cambio de clave de manera periódica.
</p>

<p>
Parágrafo tercero: En caso de pérdida, olvido o exposición a terceros de la clave, deberá remitirse a la sección de autenticación del sitio en donde hay una opción para recordar contraseña, y en donde siguiendo las instrucciones, el cliente podrá recuperar su contraseña, a través de su correo electrónico o cambiar la clave.
</p>


<h2>
La actividad
</h2>

<p>
{storeData.domain} pondrá a disposición de los clientes, los colores en los que pueden adquirir los productos. Estos se exhibirán de la manera más real posible, sin embargo hay que tener en cuenta que con cada equipo/computador, el color que se elija podrá variar, por lo que {storeData.domain} no se hace responsable de este hecho si el cliente solicitara cambio por error en la selección del color.
</p>

<h2>
Aceptación de los términos
</h2>

<p>

Al ingresar, hojear y/o usar este sitio, el usuario admite haber leído y entendido estos términos de uso y está de acuerdo en sujetarse a los mismos y cumplir con todas las leyes y reglamentos aplicables que hagan parte de la legislación colombiana. Además, cuando el usuario utilice cualquier servicio suministrado en este sitio, estará sujeto a las reglas, guías, políticas, términos y condiciones aplicables a dicho servicio en particular. {storeData.domain} no se responsabiliza de que el material en este sitio sea apropiado o esté disponible para su uso en otros lugares, estando prohibido su acceso desde territorios donde su contenido sea ilegal. Aquellos que decidan ingresar a este sitio desde otros lugares lo harán bajo su propia iniciativa y es su responsabilidad el sujetarse a las leyes locales que sean aplicables. En caso de que el usuario no esté de acuerdo con estos términos, favor abstenerse de usar este sitio. Cualquier reclamo con relación a este sitio y el material en él contenido está regulado por las leyes de Colombia. Estos términos y condiciones están sujetos a cambios sin previo aviso en cualquier momento, bajo el principio de autonomía de voluntad de {storeData.domain}  y a partir de la fecha de modificación de estos términos y condiciones, todas las operaciones que se celebren entre {storeData.domain}  y el usuario se regirán por el documento modificado.
</p>

<h2>

Las disposiciones
</h2>

<p>

En caso de que una o más de las disposiciones contenidas en estos términos y condiciones sean consideradas nulas, ilegales o ineficaces en cualquier aspecto, la validez, legalidad, exigibilidad o eficacia del resto de las disposiciones aquí contenidas no se verán afectadas o anuladas por dicha circunstancia.
</p>

<h2>

Revisión de los términos
</h2>
<p>

{storeData.domain}  puede en cualquier momento revisar estos términos de uso aquí contenidos, por medio del reajuste de este anuncio. Al usar www.{storeData.domain} el usuario conviene en darse por obligado por cualquiera de tales revisiones, las cuales estarán vigentes a partir del momento en que las mismas sean accesibles por los usuarios, debiendo entonces visitar periódicamente esta página para determinar los términos vigentes en ese momento a los cuales el usuario estará obligado en el evento que decida utilizar este sitio.
</p>


<h2>

Propiedad industrial
</h2>

<p>
Todas las marcas, enseñas, logos, nombres y cualesquiera otros signos distintivos, así como los modelos de utilidad y/o diseños industriales y demás elementos de propiedad industrial o intelectual insertados, usados y/o desplegados en este sitio son propiedad exclusiva de {storeData.domain} Nada en www.{storeData.domain} podrá ser desarrollado como concesión u otorgamiento a cualquier título de autorizaciones, licencias o cualquier otro derecho para usar o disponer de cualquier forma de la propiedad industrial, sin el permiso por escrito de {storeData.domain}  o del titular de los derechos de la misma. Cualquier uso no autorizado constituirá una violación a los presentes términos y condiciones y a las normas vigentes nacionales e internacionales sobre propiedad industrial.
</p>

<h2>

Derechos de autor
</h2>

<p>

Todo el material informático, gráfico, publicitario, fotográfico, de multimedia, audiovisual y/o de diseño, así como todos los contenidos, textos y bases de datos puestos a su disposición en este sitio son de propiedad exclusiva de {storeData.domain} Todos los contenidos en página web están protegidos por las normas sobre derechos de autor y por todas las normas nacionales e internacionales que le sean aplicables. Exceptuando lo expresamente estipulado en estos términos y condiciones, queda prohibido todo acto de copia, reproducción, modificación, creación de trabajos derivados, venta o distribución, exhibición de los Contenidos, de ninguna manera o por ningún medio, incluyendo, más no limitado a, medios electrónicos, mecánicos, de fotocopiado, de grabación o de cualquier otra índole, sin el permiso previo por escrito de {storeData.domain}  En ningún caso estos términos y condiciones confieren derechos, licencias y/o autorizaciones para realizar los actos anteriormente descritos. Cualquier uso no autorizado de los contenidos constituirá una violación a los presentes términos y condiciones y a las normas vigentes sobre derechos de autor, únicamente se otorga al usuario una licencia y un derecho personal, intransferible y no exclusivo para desplegar www.{storeData.domain} en pantalla de un computador ordenador o dispositivo PDA bajo su control, y para copiar los contenidos de propiedad de {storeData.domain} única y exclusivamente para uso personal no comercial, con la condición de que el usuario no modifique de ninguna forma los Contenidos y que conserve todas las leyendas de derechos de autor y de otro tipo de propiedad contenidas en los mismos. El usuario se obliga por los presentes términos y condiciones a no modificar el software del sitio de ninguna manera.
</p>

<h2>
Formación y perfeccionamiento
</h2>

<p>

El contrato de compraventa de productos de {storeData.domain} se perfecciona solamente cuando el cliente en atención a la invitación a ofrecer realizada por {storeData.domain} presente la oferta de compra mediante la selección del producto y efectúe el pago según las modalidades de pago ofrecidas en la página.
</p>

<p>

En ningún caso, {storeData.domain} estará obligado bajo ningún supuesto a aceptar una oferta de compra. Parágrafo único: Si la compra que se pretende efectuar llegare a superar una cantidad de cinco (05) productos, {storeData.domain} se reserva la potestad de enviar esta oferta de compra al canal de negocios empresariales de {storeData.domain} por considerarse una venta corporativa, con el fin de evitar la comercialización indebida de productos.
</p>

<h2>
Término para la aceptación de la oferta
</h2>

<p>

{storeData.domain} podrá aceptar la oferta de forma inmediata luego de efectuado el pago, la cual podrá ser aceptada de manera total o parcial.
</p>

<p>

Parágrafo primero: La aceptación de la oferta para transacciones hechas en el sitio, se realizará por medio del correo electrónico dirigido a la dirección suministrada por parte del cliente por medio del asunto “Confirmación de Pedido en www.{storeData.domain}” u otra similar. No obstante, en todo caso se entenderá como aceptada la oferta en el momento en que {storeData.domain} despache los productos al cliente. Debe tener en cuenta nuestro cliente, que el mero registro, el suministro de la clave personal a nuestro cliente o la remisión de la información o transacción no significa aceptación de ninguna oferta.
</p>

<p>

Parágrafo segundo: En el evento que {storeData.domain} por cualquier motivo no acepte la oferta formulada de manera total o parcial, procederá a devolver los dineros de forma total o parcial según corresponda, a una cuenta de titularidad del oferente en una cuantía idéntica a la consignada en nuestras cuentas, sin ningún tipo de interés, indemnización u otros rubros.
</p>

<p>

Parágrafo tercero: Para la devolución del dinero se observará el medio de pago de la siguiente manera: Para pagos por medio de tarjeta débito, de cuenta de ahorros o corriente, la devolución se efectuará en un plazo de ocho (8) días hábiles. Pero si el pago se realizó con tarjeta de crédito, la orden de devolución se efectuará en quince (15) días hábiles, sin que exista responsabilidad de {storeData.domain} por las demoras que pueda tener la institución financiera.
</p>

<p>

Si solicitas la devolución de tu dinero el reembolso se hará dependiendo del medio de pago que hayas usado durante tu compra: Para pagos con tarjetas de crédito, tarjetas débito/PSE los tiempos pueden variar dependiendo de las variables en la operación de las diferentes entidades financieras, y para el caso de Efecty y Baloto, los giros se harán una vez restablecida la normalidad. No olvides que como opción adicional te ofrecemos un vale de pago cargado por el valor de tu compra para que lo utilices en un nuevo pedido, si así lo deseas, por favor indícanos en tu correo para generarlo y enviarte las condiciones de uso.
</p>

<h2>

Precio
</h2>

<p>

El valor total de la compra estará compuesto de los siguientes rubros a cargo del cliente: valor del producto, impuestos y gastos de transporte si fuere el caso.
</p>

<p>

Parágrafo primero: {storeData.domain} se compromete a revisar constantemente y a actualizar los precios que se mencionan en la página web y a su vez, nuestro cliente y/o usuario, debe estar atento en caso de presentarse alguna fluctuación en los mismos.
</p>

<p>

Los precios y descuentos pueden variar entre tiendas y en www.{storeData.domain}
</p>


<p>

Parágrafo segundo: {storeData.domain} informará o publicará la tarifa de transporte y envío que tendrán los bienes los cuales se generarán dependiendo de los costos, rubros y políticas de {storeData.domain} transportadora, las cuales son independientes autónomas y ajenas a {storeData.domain} Dentro del costo del flete se deberá tener en cuenta el lugar del territorio colombiano al cual se deban enviar los productos adquiridos, el tamaño y el peso de los mismos.
</p>

<h2>
Condiciones de pago
</h2>

<p>

El pago se efectuará única y exclusivamente por los siguientes medios:

- Pago contra entrega

- Tarjetas crédito: Visa, MasterCard, Diners, American Express y Codensa.

- Tarjetas débito: Maestro y Electron

- Otros medios de pago: Efecty y Baloto.
</p>

<p>

Parágrafo primero: Antes de la aceptación por parte nuestra de cualquier oferta de compra, el cliente deberá elegir los términos y condiciones de pago del precio correspondiente, según los medios de pago que se encuentran ya específicamente establecidos en este sitio. Aun cuando {storeData.domain} ponga a disposición del cliente un sistema de conexión segura para toda la realización de todas las ofertas de compra, en ningún caso será responsable por los fallos en las comunicaciones de las entidades bancarias o de crédito, así como tampoco de los daños causados a los usuarios con ocasión de una acción u omisión de dichas entidades.
</p>

<p>

Parágrafo segundo: La redención de tarjetas regalo físicas (tarjetas plásticas) o bonos regalo (bonos de papel) no es aplicable para compras a través de este sitio web, éstas únicamente se realizan en tiendas a nivel nacional. En www.{storeData.domain} puedes hacer uso de las tarjetas regalo digitales.”.
</p>



<h2>

Derecho de retracto
</h2>

<p>

De acuerdo con lo previsto en la Ley 1480 de 2011, para ejercer este derecho el consumidor deberá devolver el producto a {storeData.domain} por los mismos medios y en las mismas condiciones en que lo recibió, acercándose a un punto autorizado de la transportadora y utilizando únicamente la guía suministrada dentro del término previsto para ello.
</p>

<p>

El término para máximo para ejercer el derecho de retracto será dentro de los primeros cinco (5) días hábiles siguientes, contados a partir de la entrega del bien al consumidor.
</p>

<p>

Se exceptúan, según el objeto social de {storeData.domain} los siguientes casos:
</p>

<p>

En los contratos de suministro de bienes o servicios cuyo precio esté sujeto a fluctuaciones de coeficientes del mercado financiero que el productor no pueda controlar.
En los contratos de suministro de bienes confeccionados conforme a las especificaciones del consumidor o claramente personalizados.
En los contratos de adquisición de bienes de uso personal.
En caso de que se cumplan las condiciones mencionadas, {storeData.domain} deberá devolverle en dinero al consumidor todas las sumas pagadas sin que proceda a hacer descuentos o retenciones por concepto alguno. En todo caso la devolución del dinero al consumidor no podrá exceder de treinta (30) días calendario desde el momento en que ejerció el derecho.

Para conocer más a fondo de su derecho y de las obligaciones que de él se desprenden para ejercerlo, por favor consultar en www.sic.gov.co
</p>

<h2>

Reversión del pago
</h2>

<p>

La ley dispone que en las ventas efectuadas mediante mecanismos de comercio electrónico, tales como Internet y donde se haya utilizado para realizar el pago una tarjeta de crédito, débito o cualquier otro instrumento de pago electrónico, los participantes del proceso de pago deberán reversar los pagos que solicite el consumidor cuando sea objeto de fraude, o corresponda a una operación no solicitada, o el producto adquirido no sea recibido, o el producto entregado no corresponda a lo solicitado o sea defectuoso.
</p>

<p>

Para que proceda la reversión del pago, dentro los cinco (5) días hábiles siguientes a la fecha en que el consumidor tuvo noticia de la operación fraudulenta o no solicitada o que debió haber recibido el producto o lo recibió defectuoso o sin que correspondiera a lo solicitado, el consumidor deberá presentar queja ante el {storeData.domain} y devolver el producto, cuando sea procedente, y notificar de la reclamación al emisor del instrumento de pago electrónico utilizado para realizar la compra, el cual, en conjunto con los demás participantes del proceso de pago, procederán a reversar la transacción al comprador.
</p>


<h2>

Remisión de los productos
</h2>

<p>

El envío de los productos se realizará únicamente dentro del territorio colombiano, a través de correo certificado, en un plazo máximo de siete (15) días hábiles, contados a partir de la aceptación de la oferta, siempre y cuando no medie ningún caso fortuito o fuerza mayor, entre los cuales se encuentra a manera de ejemplo, hechos del hombre o de la naturaleza, como huelgas, paros, revoluciones, rebelión sedición, asonada, atentados, cortes de fluidos, derrumbes, terremotos, avalanchas, desbordamientos, caídas de puentes, entre otros.
</p>

<p>
Parágrafo primero: El lugar de envío será a dirección señalada por el cliente en la oferta que este elabore en el formato destinado para tal fin, el cual podrá ser el mismo lugar de habitación del comprador u otro que este designe. Se entiende que cualquier persona que se encuentre en el domicilio donde se debe realizar la entrega, se encuentra debidamente autorizado por el cliente para recibir su pedido, por lo que {storeData.domain} queda exonerado de cualquier responsabilidad al momento de la entrega, siempre y cuando la misma se haga en el domicilio registrado al momento de la compra en el sitio web.
</p>

<p>

Parágrafo segundo: {storeData.domain} transportadora tendrá la obligación de hacer máximo dos (2) intentos de entrega de los productos adquiridos. En caso que los intentos de entrega resulten infructuosos, retornarán los bienes a la fábrica y se programará con el cliente un nuevo despacho. Si no se logra acordar la entrega del producto, este será almacenado durante seis (6) meses tiempo durante el cual el cliente deberá comunicarse con {storeData.domain} a través de los canales de servicio al cliente. Superado este periodo se entenderá que el cliente desiste de su compra. Siempre y cuando el pago se haya hecho a través de tarjeta de crédito, se procesará la devolución de los dineros consignados al cliente, salvo el valor del envío, sin ningún tipo de interés, retribución o suma adicional y sin importar la causa u origen que pueda tener la devolución.
</p>

<p>

Igualmente se considera entrega infructuosa si el destinatario del producto es menor de catorce (14) años y no se encuentra acompañado de un padre, tutor o acudiente que firme junto con el destinatario el recibido del producto.
</p>

<h2>

Factura
</h2>

<p>

El cliente acepta que para efectos de practicidad y la no solicitud de datos fiscales, la factura de su pedido sea emitida a Consumidor final. Si lo desea, puede solicitar a través de cualquiera de los medios de contacto (Línea de atención, chat online o vía e-mail) la factura a nombre propio enviando una copia del RUT, correo electrónico de notificación digital, y demás datos necesarios para la emisión.
</p>

<h2>

Transmisión de la propiedad
</h2>

<p>

La transmisión de la propiedad se realiza tan pronto como {storeData.domain} coloque el bien o el producto en manos de {storeData.domain} transportadora, para ser remitido al cliente o a la persona que este designe.
</p>


<p>

Parágrafo primero: No obstante lo anterior, el cliente o destinatario del bien o producto, deberá abstenerse de recibir el mismo inmediatamente, en caso de que el empaque o embalaje del producto, presente daños, rupturas, aberturas u otras similares, dejando la debida anotación o constancia de ese hecho.
</p>

<h2>

Embalaje de los productos
</h2>


<p>

Nuestro cliente acepta que los productos sean empacados y presentados en bolsa plástica.
</p>


<h2>

Garantía de los productos
</h2>

<p>

La garantía para zapatos www.{storeData.domain} es de dos (2) meses por defectos evidentes de fabricación, bajo condiciones normales de uso. La garantía no aplica por cortes mecánicos, exposición a temperaturas extremas, contacto con ácidos o solventes, desgaste, abrasión y tensiones excesivas, modificaciones al diseño original, daños causados por terceros (transportadores) durante viajes e intervención de personas ajenas al taller de reparaciones y garantías de www.{storeData.domain}.
</p>

<p>

Para hacer efectiva la garantía de cualquiera de los productos comercializados por nuestra página web, el cliente debe seguir el siguiente procedimiento según el caso:
</p>

<p>

www.{storeData.domain} dispone de un plazo para devoluciones de 30 días calendario a partir de la fecha en que la transportadora entrega tu pedido en la dirección suministrada en la compra. Debes notificar acerca de la devolución antes de que se cumplan los 30 días calendario a través de alguno de nuestros canales de atención. Puedes realizar los cambios a través de www.{storeData.domain} y en nuestras tiendas físicas (aplican condiciones)
</p>

<p>

Si aún se encuentra dentro de los 10 días hábiles para hacer la solicitud, el cliente deberá notificar a través de cualquiera de los medios de contacto (Línea de atención, chat online o vía e-mail) informando el nombre completo y número de cédula de comprador, número de la orden del pedido, número de factura, para que se autorice la remisión del producto por medio del servicio de transporte que señale {storeData.domain}.
</p>

<p>

El producto se someterá a los conceptos del departamento de calidad quienes indicarán si es procedente la garantía y la forma en que ella se realizará. En caso contrario {storeData.domain}, generará una respuesta formal explicando los motivos por los cuales no procede la garantía y devolverá el producto(s) a la dirección de envío inicial.
</p>

<p>

Parágrafo primero: El cliente acepta y declara que {storeData.domain} no tendrá ningún tipo de responsabilidad por el transporte del producto que remita, en atención a que éste contrato es totalmente autónomo e independiente del presente.
</p>

<p>

IMPORTANTE. ¡RECUERDE QUE! Nuestros productos están hechos con telas con acabados especiales para garantizarte protección por lo tanto debes:
</p>

<p>

Evitar el contacto directo de prendas de colores claros con oscuros, lavar separadamente o con colores similares y no almacenar en húmedo, en los procesos de lavado y secado puede presentarse migración por esto es necesario seguir las instrucciones de cuidado descritas para cada prenda.
</p>

 
<h2>

Cambio del producto
</h2>

<p>

El cliente deberá solicitar el cambio a través de cualquiera de los medios de contacto (Línea de atención, chat online o vía e-mail), informando el nombre completo y número de cédula de comprador, número de la orden del pedido, número de factura para que en un plazo no mayor a cinco (5) días hábiles, por medio de un correo electrónico u otro sistema que a juicio de {storeData.domain} resulte conveniente se autorice la remisión del producto por medio del servicio de transporte que señale {storeData.domain} y en caso de que resulte procedente la solicitud, remitirnos el producto. El cambio se hará de acuerdo a las políticas de cambios y devoluciones vigentes y aplicables a los productos adquiridos.
</p>

<p>

Parágrafo único: Sin perjuicio de lo anterior, toda venta efectuada se deberá considerar como una venta en firme, por lo tanto no se admitirá la devolución del producto o el dinero que no estén respaldadas en la ley o en orden de autoridad competente, dicha devolución de dinero en todo caso se efectuará sin ningún tipo de intereses, primas o sumas adicionales, e igualmente se descontarán todos los gastos de envío que se hubiesen originado si no existe prohibición legal.
</p>

<h2>

Comentarios
</h2>

<p>

{storeData.domain} Se reserva el derecho de publicar o abstenerse de publicar cualquiera de los comentarios efectuados por los usuarios de nuestra página web a los productos. En este mismo sentido, en cualquier momento podrá un comentario ser retirado de la página web mencionada.
</p>

<p>

Parágrafo único: Todo comentario que se publique, deberá ser efectuado con un lenguaje cordial, respetuoso y relacionado con el objeto sobre el cual se comenta.
</p>


<h2>

Responsabilidad limitada
</h2>

<p>

Sin perjuicio de lo determinado en las normas imperativas de la Legislación Colombiana aplicable, {storeData.domain} no asume responsabilidad alguna, incluyendo cualquier responsabilidad por cualquier daño o perjuicio, incluyendo mas no limitado la pérdida de información o utilidades, existencia de virus, resultados del uso o la incapacidad para usar el material en este Sitio, oportunidades de negocios perdidas, o cualquier otro daño, aun cuando el usuario nos haya avisado acerca de la posibilidad de tales daños, o por cualquier reclamo de terceros, salvo lo que expresamente aquí se estipula. Bajo los términos aquí señalados, {storeData.domain} no asume ninguna responsabilidad por la información que se suministra en la página, incluyendo pero sin limitarse a la referente a productos y/o servicios, notas de interés, opiniones, consejos prácticos y solución de inquietudes. {storeData.domain} no asume responsabilidad alguna por la imposibilidad de, o por problemas en, la utilización del Sitio o de alguna de las páginas que lo conforman, incluyendo pero sin limitarse a eventos tales como problemas en el servidor o en la conexión, interrupciones en su comunicación, problemas técnicos. En caso de que el uso del material de este Sitio dé como resultado la necesidad de dar servicio a, reparar o corregir equipo o información, el usuario asume cualquier costo derivado de ello.
</p>

<p>

Parágrafo primero: La responsabilidad de {storeData.domain} se limitará en una cuantía idéntica al valor del producto adquirido, o en su defecto, al valor del producto solicitado por el cliente.
</p>

<h2>

Origen de los fondos
</h2>

<p>

El cliente solemnemente declara y sostiene:
</p>

<p>

Los recursos con los cuales efectuó la compra, provienen de operación, oficio, profesión actividad o negocio lícito.

b. Los dineros con los que efectuó la compra NO fueron obtenidos en virtud de cualquier tipo de conducta que esté consagrada en la ley colombiana como falta constitutiva de infracción penal.

c. Nunca he permitido que terceras personas utilicen mis cuentas o mis tarjetas de crédito o débito para consignar o administrar dineros que desconozca su origen o provengan de conductas contrarias a la ley y especialmente a la ley penal.

d. Eximo a {storeData.domain} de toda responsabilidad por la información errónea, falsa, inexacta que se hubiese suministrado en este documento o por la violación del mismo, de tal suerte que seré el único responsable por ello.
</p>

<h2>

Política de privacidad
</h2>


 
<p>
Datos personales
Se trata de garantizar la privacidad y protección de los datos brindados por los clientes para perfeccionar la venta, teniendo en cuenta que el suministro de estos datos es totalmente voluntario y que sólo es requerido para efectos de envío de productos y cancelación de precios, {storeData.domain} mantiene la confidencialidad de los datos requeridos y sólo serán utilizados para efectos del contrato entre el cliente y nosotros.
</p>

<p>

Responsabilidad del usuario
Al ingresar a nuestro sitio, el usuario adquiere el compromiso de suministrar información personal correcta y verdadera, así como proceder a la actualización de sus datos cada vez que se requiera. De igual forma, el usuario se obliga a notificar oportunamente a sus correspondientes entidades del sector financiero o cooperativo, la pérdida o robo de su tarjeta de crédito o de los demás instrumentos facilitados por las mismas para realizar transacciones, tales como tarjetas débito, claves personales, etc., con el fin de que tales instrumentos sean inhabilitados por las mismas. Se le prohíbe al usuario poner en, o transmitir a, o desde este Sitio cualquier material ilegal, amenazador, calumniador, difamatorio, obsceno, escandaloso, pornográfico o profano, o cualquier otro material que pudiera dar lugar a cualquier responsabilidad civil o penal en los términos de la ley.
</p>

<p>

www.{storeData.domain} recolecta información personal de sus clientes con fines promocionales exclusivamente y los medios de contacto, previa autorización de los clientes, son e-mail, SMS y correo directo. La información de los clientes se recolecta a través de rifas y concursos en tiendas, registro en página web, registro en el punto de venta y actividades con seguidores de la marca en redes sociales.
</p>

<p>

Las comunicaciones que se enviarán a los clientes serán correos electrónicos de bienvenida a la base de datos de www.{storeData.domain}, newsletter con información del producto, mensajes de cumpleaños, información sobre eventos especiales y dinámicas promocionales, mensajes en fechas especiales y otros que impliquen información de producto o promoción.
</p>

      </div>
    )
  }
}
